module.exports = __webpack_public_path__ + "static/media/HomeGalleryBg-sm.59126ad1.jpg";